import React from "react";
import { useTheme } from "../Context/ThemeContext";

function Heading({ heading, className }) {
    const { theme, selectedColor, colors, secondaryColor } = useTheme();

    return (
        <h2
            className={`flex items-center relative w-full whitespace-nowrap mt-5 md:mt-10 mb-5 md:mb-0 text-xl md:text-3xl font-extrabold ${secondaryColor} after:block after:relative after:h-[1px] after:w-full after:ml-5 after:${colors[theme].colors[selectedColor].bgSecondary} ${className}`}
        >
            {heading}
        </h2>
    );
}

export default Heading;
